export const productMessages = {
  'detail.addCart': 'Add to cart',
  'detail.addOk': 'Added to cart!',
  'detail.adding': 'Adding…',
  'detail.avg': 'Avg.',
  'detail.favCount': 'Saves',
  'detail.favFail': 'Favorite failed',
  'detail.favorite': '♡ Save',
  'detail.favorited': '♥ Saved',
  'detail.guestTip': 'Sign in to buy, favorite and rate',
  'detail.myRate': 'My rating: ',
  'detail.noDesc': 'No description',
  'detail.premium': 'Premium',
  'detail.rateFail': 'Rating failed',
  'detail.ratePrompt': 'Rate 1–5 stars',
  'detail.reviewWrap': '({n} reviews)',
  'detail.reviewsShort': 'reviews',
  'detail.sold': 'Sold',
  'detail.stock': 'Stock',
  'productList.allCats': 'All categories',
  'productList.empty': 'No products yet',
  'productList.errHint': 'Check the API server and refresh',
  'productList.loadFail': 'Failed to load products',
  'productList.noMatch': 'No matches — clear filters',
  'productList.of': '/',
  'productList.retry': 'Reload',
  'productList.searchPh': 'Search name or shop…',
  'productList.showing': 'Showing',
  'productList.sortDefault': 'Default',
  'productList.sortPriceAsc': 'Price ↑',
  'productList.sortPriceDesc': 'Price ↓',
  'productList.sortSales': 'Best selling',
  'productList.sub': 'Quality goods nationwide, fast delivery',
  'productList.title': 'Products',
  'productList.unit': 'items',
  'shop.badgePremium': 'Premium shop',
  'shop.defaultTagline': 'Curated for you',
  'shop.empty': 'No items on sale',
  'shop.followers': 'Followers',
  'shop.goodsTitle': 'Products',
  'shop.loadFail': 'Failed to load shop',
  'shop.onSale': 'On sale',
  // Reviews
  'review.title': 'Customer Reviews',
  'review.count': 'reviews',
  'review.all': 'All',
  'review.empty': 'No reviews yet. Be the first!',
  'review.noFiltered': 'No reviews match this filter',
  'review.noContent': 'No written review',
  // Pagination
  'pagination.total': 'Total {n}',
  'pagination.perPage': 'per page',
  'pagination.prev': 'Prev',
  'pagination.next': 'Next',
  // Search page
  'search.button': 'Search',
  'search.pagePlaceholder': 'Search products, shops…',
  'search.history': 'Search History',
  'search.hot': 'Hot Searches',
  'search.clearHistory': 'Clear',
  'search.resultCount': '{n} products found',
  'search.noResult': 'No products found',
  'search.noResultHint': 'Try a different keyword',
  // Compare
  'compare.title': 'Product Comparison',
  'compare.field': 'Attribute',
  'compare.selected': '{n} items selected',
  'compare.compareBtn': 'Compare',
  'compare.minHint': 'Select at least 2',
  'compare.clearAll': 'Clear All',
  'compare.empty': 'No products selected for comparison',
  'compare.goShopping': 'Browse Products',
  'compare.price': 'Price',
  'compare.originalPrice': 'Orig. Price',
  'compare.category': 'Category',
  'compare.shop': 'Shop',
  'compare.shopCredit': 'Shop Credit',
  'compare.sales': 'Sales',
  'compare.stock': 'Stock',
  'compare.rating': 'Rating',
  'compare.reviewCount': 'Reviews',
  'compare.favCount': 'Favorites',
  'compare.isPremium': 'Premium',
  'compare.addToCompare': 'Compare',
};
